import Permission from '@constants/permission'
import React, { ChangeEvent, ReactElement, useState } from 'react'
import hasPerms from '@utils/has-permission'
import { Button } from '@mui/material'
import { POST } from '@utils/api'
import { makeStyles } from 'tss-react/mui'
import { setFlashMessage } from '@store/reducers/flash-message/actions'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles()((theme) => ({
  downloadSection: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
}))

const PLUUpdate = (): ReactElement => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const [csvUploadFile, setCsvUploadFile] = useState<File>()
  const [uploading, setUploading] = useState(false)
  const [downloadButtonState, setDownloadButtonState] = useState(
    'Download Spreadsheet',
  )
  const [downloadFileState, setDownloadFileState] = useState('')
  const [uploadFileState, setUploadFileState] = useState('')
  const canEdit = hasPerms(Permission.MASS_PRICE_CHANGE_UPDATE)

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) setCsvUploadFile(e.target.files[0])
  }

  const importCsvFile = async () => {
    if (uploading) return
    if (!csvUploadFile) {
      dispatch(setFlashMessage('Select a file to upload.', 'error'))
      return
    }
    setUploading(true)
    setUploadFileState(
      'Your spreadsheet is uploading to the server, do not close your browser.',
    )
    try {
      const data = new FormData()
      data.append('plus', csvUploadFile)
      const {
        data: { email },
      }: { data: { email: string } } = await POST('/p4/plus/import', data)
      dispatch(setFlashMessage('Upload complete, updating prices.', 'success'))
      setUploadFileState(
        `File upload successful. Prices are updating on the server and should be changed within 2 minutes. Check your email ${email} for an update when this is completed.`,
      )
      setUploading(false)
    } catch (error: any) {
      dispatch(setFlashMessage(error.message, 'error'))
    }
  }

  const handleDownload = async () => {
    setDownloadButtonState('Starting Download...')

    const {
      data: { filename, email },
    }: { data: { filename: string; email: string } } =
      await POST('/p4/plus/export')

    setDownloadButtonState('Download Spreadsheet')
    setDownloadFileState(
      `Generating file ${filename} and will email to ${email} in about 5 minutes.`,
    )
  }

  return (
    <>
      <h1>Mass PLU Update</h1>
      <div className={classes.downloadSection}>
        <h2>1. Download the current PLU list.</h2>
        <Button onClick={handleDownload}>{downloadButtonState}</Button>
        <p>{downloadFileState}</p>
      </div>
      <div>
        <h2>2. Update the price column of the spreadsheet.</h2>
        <ul>
          <li>Rows require a price value is set.</li>
          <li>Rows require that the variant_id is unchanged for mapping.</li>
          <li>Rows require that the store_id is unchanged for mapping.</li>
        </ul>
        <h2>
          3. Upload the updated spreadsheet to change to the new prices
          immediately.
        </h2>
        <input disabled={!canEdit} onChange={handleFileChange} type='file' />
        <Button disabled={!canEdit} onClick={importCsvFile}>
          {uploading ? 'Processing...' : 'Import'}
        </Button>
        <p>{uploadFileState}</p>
      </div>
    </>
  )
}

export default PLUUpdate
